<template>
  <div>
    <span class="d-block mt-2 mb-4">
      {{ $t('ACADEMICO.DESCRICAO_FORMULARIO_CONTRATOS_TURMA_ADITIVO') }}
    </span>

    <hr />

    <b-row>
      <b-col cols="12" md="3">
        <input-select
          :disabled="!opcoes.anosLetivos?.length"
          ref="form.anoLetivoId"
          :options="opcoes.anosLetivos"
          v-model="filtro.anoLetivoId"
          :label="$t('GERAL.ANO_LETIVO')"
          valueField="id"
          textField="ano"
          required
          @input="getCursos"
        />
      </b-col>
      <b-col cols="12" md="3">
        <input-select-search
          ref="form.cursoId"
          :isDisabled="!opcoes.cursos?.length"
          :options="opcoes.cursos"
          v-model="filtro.cursoId"
          :label="$t('GERAL.CURSO')"
          required
          @input="getGrupoTurma"
        />
      </b-col>
      <b-col cols="12" md="3">
        <input-select
          ref="form.grupoTurmaId"
          :options="opcoes.grupoTurmas"
          v-model="filtro.grupoTurmaId"
          :label="$t('GERAL.GRUPO_TURMA')"
          :disabled="!opcoes.grupoTurmas?.length"
          required
          @input="getTurmas"
        />
      </b-col>
      <b-col cols="12" md="3">
        <input-select
          ref="form.turmaId"
          :options="opcoes.turmas"
          v-model="filtro.turmaId"
          :label="$t('GERAL.TURMA')"
          valueField="id"
          textField="descricao"
          :disabled="!filtro.grupoTurmaId"
          required
        />
      </b-col>
      <b-col md="12" class="text-right">
        <b-button variant="primary" @click="getContratosPorTurma">
          {{ $t('ACADEMICO.LISTAR_CONTRATOS') }}
        </b-button>
      </b-col>
    </b-row>

    <hr />

    <b-row>
      <b-col>
        <div class="mb-2">
          <h4>{{ $t('ACADEMICO.SELECIONE_CONTRATOS') }}</h4>

          <div>
            <input-checkbox
              :label="$t('ACADEMICO.SELECIONAR_TODOS')"
              v-model="todosSelecionados"
              @change="selecionarTodos"
            />
          </div>
        </div>
        <b-table
          ref="selectableTable"
          :fields="colunas"
          :items="opcoes.contratos"
          @row-selected="adicionar"
          :empty-text="$t('GERAL.NENHUM_REGISTRO')"
          head-variant="light"
          select-mode="multi"
          responsive="sm"
          show-empty
          selectable
          striped
        >
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <i class="blue text-md fas fa-check-square d-flex"></i>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <i class="text-md far fa-square d-flex"></i>
              <span class="sr-only">Not selected</span>
            </template>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

import AnoLetivoService from '@/common/services/anoLetivo/ano-letivo.service';
import GrupoTurmaService from '@/common/services/grupoTurma/grupo-turma.service';
import CursoService from '@/common/services/academico/curso.service';
import TurmaService from '@/common/services/academico/turma.service';

import { InputSelect, InputSelectSearch, InputCheckbox } from '@/components/inputs';

export default {
  name: 'ContratosPorTurma',

  components: {
    InputSelect,
    InputCheckbox,
    InputSelectSearch,
  },
  props: {
    form: { type: Object, default: Object },
    filtro: { type: Object, default: Object },
  },
  data() {
    return {
      opcoes: {
        anosLetivos: [],
        cursos: [],
        grupoTurmas: [],
        turmas: [],
        contratos: []
      },
      colunas: [
        {
          key: 'selected',
          label: this.$t('GERAL.SELECIONADO'),
        },
        {
          key: 'codigo',
          label: this.$t('ACADEMICO.CODIGO'),
          sortable: true,
        },
        {
          key: 'turma',
          label: this.$t('ACADEMICO.TURMA'),
        },
        {
          key: 'nome',
          label: this.$t('ACADEMICO.ALUNO'),
          sortable: true,
        },
      ],
      contratos: [],
      todosSelecionados: false,
    };
  },
  mounted() {
    this.getAnosLetivo();
  },
  methods: {
    adicionar(items) {
      const contratosId = items.map((item) => item.id);
      this.form.contratos = contratosId;
    },
    limparFiltro() {
      this.opcoes.turmas = [];
      this.opcoes.contratos = [];
      this.filtro = {
        anoLetivoId: '',
        cursoId: '',
        grupoTurmaId: '',
        turmaId: '',
      };
    },

    selecionarTodos() {
      if (this.todosSelecionados) return this.$refs.selectableTable.selectAllRows();
      return this.$refs.selectableTable.clearSelected();
    },

    getContratosPorTurma() {
      this.$store.dispatch(START_LOADING);
      TurmaService.listarContratoPorTurmaId(this.filtro)
        .then(({ data }) => {
          this.opcoes.contratos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getAnosLetivo() {
      this.$store.dispatch(START_LOADING);
      AnoLetivoService.listar(this.paginacao, true)
        .then(({ data }) => {
          this.opcoes.anosLetivos = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getCursos() {
      if (!this.filtro.anoLetivoId?.length) return;
      this.opcoes.cursos = [];
      this.opcoes.grupoTurmas = [];
      this.opcoes.turmas = [];
      this.$store.dispatch(START_LOADING);
      CursoService.obterPorAnoLetivo(this.filtro.anoLetivoId)
        .then(({ data }) => {
          this.opcoes.cursos = data.map((row) => ({
            text: row.descricao,
            value: row.id,
          }));
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getGrupoTurma() {
      this.$store.dispatch(START_LOADING);
      
      GrupoTurmaService.buscarGrupoTurmaPorCursoIdAnoLetivoOpcoes(
        this.filtro.cursoId,
        this.filtro.anoLetivoId
      )
        .then((data) => {
          this.opcoes.grupoTurmas = data;
          this.filtro.grupoTurmaId = '';
          this.opcoes.turmas = [];
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    getTurmas() {
      this.$store.dispatch(START_LOADING);

      TurmaService.obterTurmaPorGrupoTurmaCursoAnoLetivo(this.filtro)
        .then(({ data }) => {
          this.opcoes.turmas = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
};
</script>
